import { LocaleKeys } from "src/internationalization/CustomIntlProvider";
import { BlacklistElementOrigin } from "src/types/blacklist";

export const BLACKLIST_ORIGIN_LABELS: Record<BlacklistElementOrigin, LocaleKeys> = {
  manual: "page.blacklists.table.header.origin.manual",
  caseIdentifier: "page.blacklists.table.header.origin.imported",
  import: "page.blacklists.table.header.origin.alert",
};
